import Swiper from 'swiper';
import viewport from "./viewport";

export default function() {

    let compositionSlides = document.getElementsByClassName('js-composition-slider')[0];

    window.compositionSwiper = new Swiper(compositionSlides, {
        loop: false,
        speed: 600,
        spaceBetween: 30,
        effect: 'coverflow',
        coverflowEffect: {
            rotate: 0,
            slideShadows: false,
        },
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        centeredSlides: true,
        breakpoints: {
            765: {
                spaceBetween: 20,
                slidesPerView: 2,
            },
            980: {
                spaceBetween: 20,
                slidesPerView: 3,
            },
            1366: {
                spaceBetween: 30,
                slidesPerView: 5,
            },
            1600: {
                spaceBetween: 30,
                slidesPerView: 7,
            }
        }
    });


    let compositionItems = document.getElementsByClassName('js-open-composition-modal');
    let compositionItemsClose = document.getElementsByClassName('js-close-composition-modal');
    let compositionModals = document.getElementsByClassName('composition-modal');
    let compositionMobileSlider = document.getElementsByClassName('js-composition-slider')[0];

    Array.from(compositionItems).forEach(button => button.addEventListener('click', function(e){

        if(viewport().width > 768) {
            Array.from(compositionModals).forEach(function (item) {
                item.classList.remove('is-opened');
            });

            let elm = e.target;

            while (elm !== document.body) {
                if (/(?:^| )js-close-composition-modal(?:$| )/.test(elm.className)) {
                    return;
                }
                elm = elm.parentNode;
            }

            this.getElementsByClassName('composition-modal')[0].classList.add('is-opened');
        }
        else{
            let index = Array.from(compositionItems).indexOf(button);

            compositionMobileSlider.classList.add('is-opened');
            window.compositionSwiper.slideTo(index, 0);
        }
        e.preventDefault();
    }));


    Array.from(compositionItemsClose).forEach(button => button.addEventListener('click', function(e){
        this.closest('.composition-modal').classList.remove('is-opened');
        compositionMobileSlider.classList.remove('is-opened');
        e.preventDefault();
    }));

}

